import ShareFunctions from './ShareFunctions';
import React, { useState } from 'react';
import { Spinner } from '../../components/ui';
import FunctionForm from './FunctionForm';
import { sideChipClass, fmtDate, fmtTime, isPastFunction } from '../../utils/helpers';

const weekday = (iso) => {
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-IN', { weekday: 'short' });
};
const mapUrl = (f) => {
  const q = f.GpsLocation || [f.Venue, f.VenueAddress, f.City].filter(Boolean).join(', ');
  return q ? `https://maps.google.com/?q=${encodeURIComponent(q)}` : '';
};
const statusClass = (s) => (s === 'Confirmed' ? 'chip ok' : s === 'Cancelled' ? 'chip danger' : s === 'Done' ? 'chip' : 'chip pend');

// Phone Functions: search · share · add on one line, then one heading per day
// (date + weekday, ⚠ when two functions of that day overlap) and a compact card
// per function - time, type, venue with a map pin, persons invited, status.
export default function FunctionsMobile({ vm }) {
  // Sharing the timetable with a guest who is invited to some of it.
  const [shareOpen, setShareOpen] = useState(false);
  const { filtered, days, loading, can, q, setQ, startAdd, startEdit, del, isTwoSided, hidePast, setHidePast, pastCount, shownCount, countsFor } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Functions</h1>
        <span className="count-pill">{shownCount}</span>
        {pastCount > 0 && (
          <label className="fn-hide-past">
            <input type="checkbox" checked={hidePast} onChange={(e) => setHidePast(e.target.checked)} /> Hide over
          </label>
        )}
      </div>

      <div className="ev-m-toolbar">
        <input placeholder="Search..." value={q} onChange={(e) => setQ(e.target.value)} />
        <button className="btn light ev-sq" title="Send these functions to a guest" aria-label="Share functions"
          onClick={() => setShareOpen(true)}>↗</button>
        {can.add && <button className="btn primary" onClick={startAdd}>+ Add</button>}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div>
        : filtered.length === 0 ? (
          <div className="card card-pad empty">No functions yet.{!can.add && ' Ask the Event Owner to add functions.'}</div>
        ) : days.map(day => (
          /* One heading per day; the functions of that day follow in time order. */
          <div key={day.date || 'nodate'}>
            <div className="ev-m-day">
              <span>
                {day.date ? `${fmtDate(day.date)} · ${weekday(day.date)}` : 'No date yet'}
                {day.clashes.size > 0 && <span className="ev-warn" title="Two functions on this day overlap in time"> ⚠ overlap</span>}
              </span>
              {day.items.length > 1 && <span>{day.items.length} functions</span>}
            </div>
            <div className="mobile-card-list" style={{ paddingBottom: 0 }}>
            {day.items.map(row => {
              const c = countsFor ? countsFor(row) : null;
              const past = isPastFunction(row);
              const time = [row.StartTime || row.FunctionTime, row.EndTime].filter(Boolean).map(fmtTime).join(' – ');
              const type = row.FunctionTypeName || row.FunctionType || '';
              const map = mapUrl(row);
              return (
                <div key={row.FunctionId}
                  className={'card card-pad mobile-record-card ev-m-card row-link' + (day.clashes.has(row.FunctionId) ? ' clash' : '') + (past ? ' ev-m-past' : '')}
                  onClick={() => vm.openRow(row)}>
                  <div className="mobile-card-head">
                    <strong className="mobile-title">{row.FunctionName || '-'}</strong>
                    <div style={{ flex: 1 }} />
                    {c && <span className="ev-m-big" title="Persons invited">{c.persons}</span>}
                  </div>
                  <div className="ev-m-line">
                    <span>🕒 {time || '-'}</span>
                    {type && type !== row.FunctionName && <span className="muted">· {type}</span>}
                    {isTwoSided && row.Side && row.Side !== 'Common' && <span className={sideChipClass(row.Side)}>{row.Side}</span>}
                  </div>
                  {(row.Venue || row.City) && (
                    <div className="ev-m-line muted">
                      {map
                        ? <a href={map} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>📍</a>
                        : '📍'}
                      <span>{[row.Venue, row.City].filter(Boolean).join(', ')}</span>
                    </div>
                  )}
                  <div className="ev-m-line">
                    <span className={statusClass(row.Status)}>{row.Status || 'Planned'}</span>
                    {past && <span className="chip">over</span>}
                    {c && <span className="muted">{c.parties} {c.parties === 1 ? 'party' : 'parties'}{c.extra > 0 ? ` · +${c.extra} extra` : ''}</span>}
                  </div>
                  {(can.edit || can.delete) && (
                    <div className="mobile-actions" onClick={(e) => e.stopPropagation()}>
                      {can.edit && <button className="btn light sm" onClick={() => startEdit(row)}>Edit</button>}
                      {can.delete && <button className="btn danger sm" onClick={() => del(row)}>Del</button>}
                    </div>
                  )}
                </div>
              );
            })}
            </div>
          </div>
        ))}
      <div style={{ height: 88 }} />

      <FunctionForm vm={vm} event={vm.event} />
      {shareOpen && <ShareFunctions functions={vm.filtered || []} event={vm.event} onClose={() => setShareOpen(false)} />}
    </div>
  );
}
